import { mutator } from 'satcheljs';
import { clearCachedAttachmentSuggestions } from '../actions/publicLazyActions';
import getMRUAttachmentStore from '../store/mruAttachmentStore';
import { KEY_NULLREFERENCEITEMID } from '../utils/constants';

export default mutator(clearCachedAttachmentSuggestions, actionMessage => {
    const store = getMRUAttachmentStore();
    const { composeId } = actionMessage;
    const referenceItemId = actionMessage.referenceItemId || KEY_NULLREFERENCEITEMID;
    const idMap = store.referenceItemIdAndComposeIdMap;
    const entries = idMap.get(referenceItemId)?.filter(e => e !== composeId);
    if (entries?.length > 0) {
        idMap.set(referenceItemId, entries);
    } else {
        idMap.delete(referenceItemId);

        if (referenceItemId !== KEY_NULLREFERENCEITEMID) {
            store.contextualAttachmentSuggestions.delete(referenceItemId);
        }
    }
});
